// extracted by mini-css-extract-plugin
module.exports = {"block":"TransferPortalNavOptions_block__Ec8bz"};